import $ from "jquery";

export default class NavigationDropdown {
    constructor() {
        this.lastMouseX = 0;
        this.lastMouseY = 0;
        this.lastTime = 0;
        this.mouseAngle = 0;

        this.activeDropdown = null;

        this.hoverTimeout = null;

        this.bindEvents();
    }

    bindEvents() {
        $(window).on("mousemove", (e) => {
            let now = (new Date).getTime();

            let dt = now - this.lastTime;

            // Only process every 50 ms
            if (dt < 50) {
                return;
            }

            let dx = e.clientY - this.lastMouseY;
            let dy = e.clientX - this.lastMouseX;

            // 0 -> Vertically Top to Bottom
            // 0.5 PI -> Horizontally Left to Right
            // 1 PI -> Vertically Bottom to Top
            // -0.5 PI -> Horizontally Right to Left
            let angle = Math.atan2(dy, dx);

            this.lastMouseX = e.clientX;
            this.lastMouseY = e.clientY;
            this.lastTime = now;

            this.mouseAngle = angle;
        });

        const me = this;
        $("body").on("mouseenter", ".js-dropdown-link", function () {
            if (me.closeTimeout) {
                clearTimeout(me.closeTimeout);
            }
            if (me.hoverTimeout) {
                clearTimeout(me.hoverTimeout);
            }

            let dropdown = $(this).attr("data-dropdown");

            if(dropdown === me.activeDropdown) {
                return;
            }

            if (me.activeDropdown === null || Math.abs(me.mouseAngle) > 1.5) {
                me.switchToDropdown(dropdown);
            } else {
                // Set a timeout to see if we're still hovering over it
                me.hoverTimeout = setTimeout(() => me.switchToDropdown($(this).attr("data-dropdown")), 400);
            }
        }).on("mouseleave", ".js-dropdown-link", () => {
            if (me.hoverTimeout) {
                clearTimeout(me.hoverTimeout);
            }
        }).on('mouseenter', ".js-dropdown-item", function () {
            if (me.closeTimeout) {
                clearTimeout(me.closeTimeout);
            }
        }).on('mouseleave', ".js-dropdown-item", function () {
            me.closeTimeout = setTimeout(() => me.closeDropdown(), 200);
        });
    }

    closeDropdown() {
        this.getDropdowns().removeClass("dropdown--active");
        $('.js-dropdown-bg-holder').removeClass('dropdown--active').find(".js-dropdown-bg").css('height', 0);

        this.activeDropdown = null;
    }

    getDropdowns() {
        return $(".js-dropdown");
    }

    getDropdownElement(dropdown) {
        return this.getDropdowns().filter("[data-dropdown='" + dropdown + "']");
    }

    switchToDropdown(dropdown) {
        if (this.activeDropdown === dropdown) {
            return;
        }
        // Close existing dropdowns
        this.closeDropdown();

        let $dropdown = this.getDropdownElement(dropdown);
        let $contentWrap = $dropdown.find(".js-dropdown-wrapper");

        let height = $contentWrap.outerHeight();

        $('.js-dropdown-bg-holder').addClass("dropdown--active").find('.js-dropdown-bg').css('height', height);
        $dropdown.addClass("dropdown--active");

        this.activeDropdown = dropdown;
    }
}
